export const dailyTraffic = [
    { day: 'Mon', count: 300 },
    { day: 'Tues', count: 900 },
    { day: 'Wed', count: 1300 },
    { day: 'Thru', count: 750 },
    { day: 'Fri', count: 1700 },
    { day: 'Sat', count: 1100}
]
